import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CrudService {

  userData:any;
  userid:any;

  constructor(private http:HttpClient) { }

  baseUrl:string = "https://ghrscf.com/classes/";
  

  //single student details
  public getOne(id:any){
    return this.http.get(this.baseUrl + 'student-details.php');
  }

}
